export default "__VITE_ASSET__BpJz4zJP__"